import { attributeValues } from './attributes'; // Returns StimulusReflex controllers local to the passed element based on the data-controller attribute.
//

const localReflexControllers = (app, element) => {
  return attributeValues(element.getAttribute(app.schema.controllerAttribute)).reduce((memo, name) => {
    const controller = app.getControllerForElementAndIdentifier(element, name);
    if (controller && controller.StimulusReflex) memo.push(controller);
    return memo;
  }, []);
}; // Returns all StimulusReflex controllers for the passed element.
// Traverses DOM ancestors starting with element.
//


export const allReflexControllers = (app, element) => {
  let controllers = [];

  while (element) {
    controllers = controllers.concat(localReflexControllers(app, element));
    element = element.parentElement;
  }

  return controllers;
};